"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALLOW_GROWTH_SUITE_STARTER_TOUCHLESS = exports.MARKETING_CONTACTS_MONTHLY_MARKING = exports.MARKETING_CONTACTS_GLOBAL_LAUNCH = void 0;
var MARKETING_CONTACTS_GLOBAL_LAUNCH = 'CBX:MarketingContactsGlobalLaunch';
exports.MARKETING_CONTACTS_GLOBAL_LAUNCH = MARKETING_CONTACTS_GLOBAL_LAUNCH;
var MARKETING_CONTACTS_MONTHLY_MARKING = 'CBX:MarketingContactsMonthlyEvaluation';
exports.MARKETING_CONTACTS_MONTHLY_MARKING = MARKETING_CONTACTS_MONTHLY_MARKING;
var ALLOW_GROWTH_SUITE_STARTER_TOUCHLESS = 'CBX:AllowGrowthSuiteStarterTouchless';
exports.ALLOW_GROWTH_SUITE_STARTER_TOUCHLESS = ALLOW_GROWTH_SUITE_STARTER_TOUCHLESS;